<template>
  <nav class="bg-primary-500 px-4 py-4 dark:border-b dark:border-gray-800 dark:bg-gray-900">
    <div class="mx-auto flex max-w-4xl items-center justify-between">
      <slot></slot>
    </div>
  </nav>
</template>
